export default {
  goal: {
    title: '目標',
    fromStudy: '由研究預先填入。結果描述的是來源版本，而非此草稿。',
    atDp: '於 {{dp}}',
  },
  files: {
    draftRow: '草稿 · 未儲存',
    draftLoading: '載入中…',
    draftRevision: 'rev {{revision}}',
  },
  viewer: {
    draft: '草稿',
    source: '來源',
    unsavedDraft: '未儲存的草稿 rev {{revision}}',
    loadingDraft: '正在載入草稿…',
    updating: '更新中…',
    earlierRevision: '顯示較早的修訂',
    draftUnavailable: '無法顯示草稿預覽：{{message}}',
    draftExpired: '草稿預覽已過期或不再可用。',
    draftClosed: '草稿已捨棄，或工作階段不再可用。',
    notSimulated:
      '草稿 rev {{revision}} 尚未進行模擬 — 這裡的所有結果都屬於 v{{version}}。',
  },
  advisor: {
    discardDraft: '捨棄草稿',
  },
  draftHealth: {
    title: '草稿健康狀況',
    sessionChecks: '工作階段檢查',
    sessionChecksHint: '助理建立此修訂時，其自身檢查的結果。',
    checksPending: '正在等待助理對此修訂的檢查。',
    checksPassed: 'rev {{revision}} 通過',
    checksPassedBody: '編輯已執行並產生實體。這不是網格化判定。',
    checksFailed: 'rev {{revision}} 未通過',
    topology: '拓撲',
    topologyUnavailable: '此修訂沒有拓撲檢查。',
    topologyPending: '正在檢查此修訂的拓撲…',
    topologyFailed: '拓撲檢查未完成',
    topologyFailedBody: '草稿仍可審查並儲存；儲存後的版本會照常診斷。',
    review: '審閱並另存為 v{{version}}',
  },
  review: {
    pair: 'v{{version}} 來源 ↔ 草稿 rev {{revision}}',
    notValidated: '尚未驗證',
    notValidatedBody:
      '此工作區中的所有壓力、溫度與力的數值都屬於 v{{version}}。此草稿從未進行模擬。',
    summaryPlaceholder:
      '變更了什麼、目標是什麼 — 例如「連接埠 Ø12 → Ø14、肋條 6 → 4，目標 ΔP ≤ 15 kPa。」',
    eyebrow: 'CadMorph 草稿',
    title: '審閱草稿 rev {{revision}}',
    summaryLabel: '變更內容',
    healthTitle: '健康狀況',
    metricsTitle: '幾何',
    blocking: '阻擋性問題',
    quality: '品質問題',
    notChecked: '尚未檢查',
    checkFailed: '檢查失敗',
    topologyFailed: '拓撲檢查：{{message}}',
    passed: '通過',
    failed: '未通過',
    reject: '拒絕',
    approve: '核准並另存為 v{{version}}',
    approvalNote: '在寫入任何內容之前，助理會在對話中請您核准此次儲存。',
    back: '返回草稿健康狀況',
  },
} as const;
